module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Regular.2f13cd2f.eot";